import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import Select from 'react-select';
import { bindActionCreators } from 'redux';
import Spinner from '../../components/svg/Spinner';
import EditInput from '../../components/forms/EditInput';
import constants from '../../constants';
import GeneralSection from '../../components/common/GeneralSection';
import VersionBox from '../../components/common/VersionBox';
import _actions from '../../actions';
import PreviewSermonsModule from '../../components/preview/PreviewSermons';
import i18n from '../../i18n';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import CloverSermons from '../../components/sermonModule/CloverSermons';
import RSSSermons from '../../components/sermonModule/RSSSermons';
import YouTubeSermons from '../../components/sermonModule/YouTubeSermons';
import VimeoSermons from '../../components/sermonModule/VimeoSermons';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';

export class SermonsModule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            menuItem: {},
            module: {},
            clearClover: false,
            showPreview: true,
        };

        this.updateModuleFieldsWithValues = this.updateModuleFieldsWithValues.bind(this);
        this.updateModuleFromEvent = this.updateModuleFromEvent.bind(this);
        this.updateModuleFeaturedId = this.updateModuleFeaturedId.bind(this);
        this.handleDisconnect = this.handleDisconnect.bind(this);
        this.updateMenuItemFromEvent = this.updateMenuItemFromEvent.bind(this);
    }

    componentDidMount() {
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getProjectVersionMenuItems(this.props.match.params.projectId);
        this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
        this.props.actions.getModuleByType(
            this.props.match.params.projectId,
            constants.ModuleType.find((mt) => {
                return mt.Name === 'Sermons';
            }).Id,
        );
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.modules.select && this.props.modules.select.id
            && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Sermons'; }).Id
            && this.props.modules.select.enabled) {
            if (this.props.alerts.data.length > 0 && this.props.alerts.data.find((m) => { return m.id === 'module-disabled'; })) {
                this.props.actions.clearAlert('module-disabled');
            }
        }
        if (!prevState.isLoaded
            || (!this.props.modules.select.enabled)) {
            if (this.props.modules.select && this.props.modules.select.id
                && this.props.modules.select.moduleType === constants.ModuleType
                    .find((m) => { return m.Name === 'Sermons'; }).Id
                && !this.props.modules.select.enabled) {
                this.props.actions.addAlert({
                    message: i18n.t('modules.sermons.error1'),
                    linkText: i18n.t('enableHere'),
                    link: `/projects/${this.props.match.params.projectId}/modules/enable-modules`,
                    view: '/modules/sermons',
                    type: 'warning',
                    id: 'module-disabled',
                });
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ isLoaded: true });
            }
        }
        if (prevProps.modules.inProgress
            && !this.props.modules.inProgress
            && this.props.modules.select
            && this.props.modules.select.enabled) {
            this.loadProjectMedia();
        }
        if ((!this.props.menuItems.inProgress
            && prevProps.menuItems.inProgress)
            || (!this.props.modules.inProgress
                && prevProps.modules.inProgress)) {
            let menuItem = this.props.menuItems.data !== []
            && typeof (this.props.modules.select.moduleType) === 'number'
                ? this.props.menuItems.data
                    .find((mi) => {
                        return mi.type === 1
                            && parseInt(mi.subType, 10) === this.props.modules.select.moduleType;
                    })
                : '';
            menuItem = menuItem || {};
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ menuItem });
        }
        if (!this.props.modules.inProgress && prevProps.modules.inProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ module: this.props.modules.select });
        }
        if (prevProps.media?.inProgress && !this.props.media?.inProgress) {
            if (this.props.media.error) {
                this.props.actions.addAlert({
                    message: i18n.t('modules.sermons.error-get-media-failure'),
                    view: '/modules/sermons',
                    type: 'error',
                    id: 'get-media-failure',
                });
            }
        }
        if (this.props.media?.select?.items !== prevProps.media?.select?.items) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ media: JSON.parse(JSON.stringify(this.props.media)) });
        }
    }

    handleDisconnect() {
        if (this.props.versions.select.cloverAccountEmail) {
            this.runClearCloverMedia();
        } else {
            this.updateVersionForFieldsWithValues([
                {
                    Name: 'mediaUrl',
                    Value: '',
                },
                {
                    Name: 'mediaType',
                    Value: undefined,
                },
                {
                    Name: 'vimeoToken',
                    Value: '',
                },
            ], true);
        }
    }

    formatItemsForSelect = (items) => {
        const formattedItems = [];
        formattedItems.push({
            label: i18n.t('modules.sermons.select'),
            value: 'auto',
        });
        // eslint-disable-next-line no-restricted-syntax
        for (const item of items) {
            formattedItems.push({
                label: item.title,
                value: item.guid,
            });
        }
        return formattedItems;
    }

    runClearCloverMedia = () => {
        this.props.actions.disconnectCloverAccount(this.props.versions.select);
        this.setState({
            clearClover: true,
        });
    };

    updateFeedUrl = (fields) => {
        this.updateVersionForFieldsWithValues(fields, false);
    };

    loadProjectMedia() {
        this.props.actions.getProjectMedia(this.props.match.params.projectId);
    }

    updateMenuItemFromEvent(evt) {
        const fieldName = evt.target.name;
        const changedValue = evt.target.value.trim().length > 0 ? evt.target.value.trim() : i18n.t('modules.sermons.sermons');
        if (changedValue !== '') {
            this.setState((prevState) => {
                return {
                    menuItem: {
                        ...prevState.menuItem,
                        title: changedValue,
                    },
                };
            });
            this.props.actions.updateMenuItemParameter(
                this.props.match.params.projectId,
                this.state.module.moduleType,
                1,
                fieldName,
                changedValue,
            );
        }
    }

    updateModuleFromEvent(evt) {
        const changedValue = evt.target.checked;
        if (changedValue) {
            this.updateModuleFieldsWithValues([{
                parameterName: 'showFeatured',
                parameterValue: true,
            }]);
        } else {
            this.updateModuleFieldsWithValues([{
                parameterName: 'showFeatured',
                parameterValue: false,
            }]);
        }
    }

    updateModuleFieldsWithValues(fields) {
        this.props.actions.updateModule(
            this.props.match.params.projectId,
            this.state.module.moduleType,
            fields,
        );
    }

    updateModuleFeaturedId(value) {
        const fieldsToBeUpdated = [
            {
                parameterName: 'featuredId',
                parameterValue: value.value === 'auto' ? null : value.value,
            },
            {
                parameterName: 'featuredType',
                parameterValue: value.value === 'auto' ? constants.FeaturedType.find((n) => { return n.Name === 'Latest'; }).Id : constants.FeaturedType.find((n) => { return n.Name === 'Featured'; }).Id,
            }];
        this.updateModuleFieldsWithValues(fieldsToBeUpdated);
    }

    updateVersionForFieldsWithValues(fields, disconnect) {
        let version = JSON.parse(JSON.stringify(this.props.versions.select));

        if (typeof version === 'string') {
            version = {};
        }
        // eslint-disable-next-line no-restricted-syntax
        for (const field of fields) {
            version[field.Name] = field.Value;
        }
        if (disconnect) {
            this.props.actions.updateProjectVersionForSermonDisconnect(
                this.props.match.params.projectId,
                version,
            );
        } else {
            this.props.actions.updateProjectVersionWithMedia(
                this.props.match.params.projectId,
                version,
            );
        }
    }

    render() {
        const mediaItems = this.props.media.select.url
            ? this.formatItemsForSelect(this.props.media.select.items)
            : [];
        let previewSermons = null;

        let selectedFeaturedId = '';
        if (mediaItems.length > 0) {
            selectedFeaturedId = this.state.module.featuredId ? this.state.module.featuredId : '';
            if (selectedFeaturedId === '') {
                selectedFeaturedId = 'auto';
            }
        }

        let bodyForm = '';

        if (this.state.module.enabled && this.props.versions?.select) {
            let activeCheckin = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Check-In'; }).Id; });
            activeCheckin = activeCheckin.filter((module) => { return module.enabled === true; });

            previewSermons = (
                <PreviewSermonsModule
                    media={this.state.media}
                    error={this.props.media?.error}
                    actionColor={this.props.versions.select.actionColor}
                    accentColor={this.props.versions.select.accentColor}
                    secondaryText={this.props.versions.select.secondaryText}
                    primaryText={this.props.versions.select.primaryText}
                    module={this.state.module}
                    menuItem={this.state.menuItem}
                    menuStyle={this.props.versions.select.menuStyle}
                    menuItems={this.props.menuItems.data}
                    checkin={
                        this.props.flags.results?.chMSIntegration
                        && this.props.flags.results?.chMSCheckIn
                        && activeCheckin.length > 0
                    }
                />
            );

            bodyForm = (
                <div
                    data-qa="sermons-module-page"
                    id="sermons-module-page"
                    className="form-wrapper"
                >

                    <h1
                        data-qa="sermons-module-header"
                        id="sermons-module-header"
                    >
                        {i18n.t('modules.sermons.header')}
                    </h1>

                    <p
                        data-qa="sermons-module-subhead"
                        id="sermons-module-subhead"
                        className="lead"
                    >
                        {i18n.t('modules.sermons.subtitle')}
                    </p>

                    <GeneralSection
                        name={i18n.t('modules.sermons.section1')}
                        sectionClass="edit-module-name module-display-settings-list"
                    >
                        <div
                            id="module-display-setting"
                            className="module-display-setting"
                        >

                            <EditInput
                                containerId="edit-module-name"
                                containerClass="edit-module-name-wrap"
                                name="title"
                                labelText={i18n.t('name')}
                                value={this.state.menuItem !== {} && this.state.menuItem.title ? this.state.menuItem.title : ''}
                                charLimit={12}
                                onBlur={this.updateMenuItemFromEvent}
                                onReturnDown={this.updateMenuItemFromEvent}
                                actionClass="edit-module-name-action"
                                placeholder={i18n.t('modules.sermons.sermons')}
                                dataqa="sermons-module-name"
                                menuTitle
                            />
                            {this.props.flags.results?.userSelectedIcons
                            && (
                                <HorizontalFormContainer
                                    inputClass="module-display-setting__setting"
                                    title="Menu Icon"
                                >
                                    <UserSelectedIconSelect
                                        id={this.state.menuItem.subType}
                                        type={this.state.menuItem.type}
                                        autoUpdate
                                    />
                                </HorizontalFormContainer>
                            )}
                        </div>
                    </GeneralSection>

                    <CloverSermons
                        handleDisconnect={this.handleDisconnect}
                        clearClover={this.state.clearClover}
                    />

                    <div data-qa="general-section" className="general-section other-import-list">

                        <RSSSermons
                            updateFields={this.updateFeedUrl}
                            handleDisconnect={this.handleDisconnect}
                        />

                        <YouTubeSermons
                            updateFields={this.updateFeedUrl}
                            handleDisconnect={this.handleDisconnect}
                        />

                        <VimeoSermons
                            updateFields={this.updateFeedUrl}
                            handleDisconnect={this.handleDisconnect}
                        />

                    </div>

                    <GeneralSection
                        name={i18n.t('modules.sermons.section2.header')}
                        sectionClass="edit-module-name module-display-settings-list"
                        dataqa="sermon-display-settings"
                    >

                        <div
                            className={`module-display-setting ${this.state.module.showFeatured ? 'module-setting-on' : 'module-setting-off'}`}
                        >
                            <HorizontalFormContainer
                                data-qa="show-featured"
                                inputClass="module-display-setting__toggle"
                                title={i18n.t('modules.sermons.section2.label1')}
                            >
                                <OnOffSwitch
                                    buttonClass="toggle checkbox md-checkbox large-switch"
                                    name="showFeatured"
                                    onChange={this.updateModuleFromEvent}
                                    isToggleOn={this.state.module.showFeatured}
                                    disabled={this.props.versions.select.mediaType === 0}
                                    tooltipText={i18n.t('modules.sermons.discover.connect')}
                                />
                            </HorizontalFormContainer>

                            <div
                                data-qa="select-featured__selector"
                                id="select-featured-section"
                                className="module-display-setting__options"
                            >
                                <h4 data-qa="select-featured-header">{i18n.t('modules.sermons.section2.label2')}</h4>
                                {this.props.media.inProgress || this.props.versions.inProgress
                                    ? <Spinner />
                                    : (
                                        <Select
                                            id="select-featured"
                                            options={mediaItems}
                                            onChange={this.updateModuleFeaturedId}
                                            className="form-selector"
                                            classNamePrefix="form-selector"
                                            value={mediaItems.length > 0 ? mediaItems.find((f) => { return f.value === selectedFeaturedId; }) : ''}
                                            name="featuredId"
                                            clearable={false}
                                            disabled={mediaItems.length === 0}
                                        />
                                    )}
                            </div>

                        </div>
                    </GeneralSection>

                </div>
            );
        }
        return (
            <VersionBox
                name={this.props.versions.select.name}
                versionNumber={this.props.versions.select.version}
                saving={this.props.modules.inProgress}
                justSaved={this.props.modules.justSaved}
                menuSection="Modules"
                menuItem="SermonsModule"
                previewCssClass="modules_sermons"
                previewChild={previewSermons}
                showPreview={this.state.showPreview}
                x
            >
                <div className="content-inside">
                    {bodyForm}
                </div>
            </VersionBox>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SermonsModule);
